import React from "react";
import Avatar from "@material-ui/core/Avatar";
import { connect } from "react-redux";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import IntlMessages from "util/IntlMessages";
import axios from "../../util/Api";
import { withRouter } from "react-router";
import { SIGNOUT_USER_SUCCESS } from "../../constants/ActionTypes";
import { clearLocalStorageData } from "../../util/localStorageService";
import { RESET_STATE } from "../../constants/ActionTypes";

class UserInfo extends React.Component {
  state = {
    anchorEl: null,
    open: false
  };

  handleClick = event => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  handleLogout = () => {
    clearLocalStorageData();
    axios.defaults.headers.common["access-token"] = "";
    this.props.resetReduxState();
    this.props.logout();
  };

  handleProfileClick = () => {
    this.props.history.push("/app/users/profiles");
  };

  render() {
    const { userInfo } = this.props;
    const userRoles = Array.isArray(userInfo?.Roles) ? userInfo.Roles : [];
    const displayName =
      userRoles.includes("administrator")
        ? userInfo?.FullName
        : userInfo?.FirstName || userInfo?.FullName || "User";
    const avatarInitials =
      `${displayName || "User"}`
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map(namePart => namePart.charAt(0).toUpperCase())
        .join("") || "U";

    return (
      <div className="user-profile d-flex flex-row align-items-center">
        <Avatar alt={displayName} className="user-avatar ">
          {avatarInitials}
        </Avatar>
        <div className="user-detail">
          <h4 className="user-name" onClick={this.handleClick}>
            {displayName}
          
            <i className="zmdi zmdi-caret-down zmdi-hc-fw align-middle" />
          </h4>
        </div>
        <Menu
          className="user-info"
          id="simple-menu"
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onClose={this.handleRequestClose}
          PaperProps={{
            style: {
              minWidth: 120,
              paddingTop: 0,
              paddingBottom: 0
            }
          }}
        >
          <MenuItem
            onClick={() => {
              this.handleRequestClose();
              this.handleProfileClick();
            }}
          >
            <i className="zmdi zmdi-account zmdi-hc-fw mr-2" />
            <IntlMessages id="popup.profile" />
          </MenuItem>
          <MenuItem onClick={this.handleRequestClose}>
            <i className="zmdi zmdi-settings zmdi-hc-fw mr-2" />
            <IntlMessages id="popup.setting" />
          </MenuItem>
          <MenuItem
            onClick={() => {
              this.handleRequestClose();
              this.handleLogout();
            }}
          >
            <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-2" />

            <IntlMessages id="popup.logout" />
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    locale: state.settings,
    userInfo: state.auth.authUser
  };
};

const mapActionToProps = dispatch => {
  return {
    logout: () => dispatch({ type: SIGNOUT_USER_SUCCESS }),
    resetReduxState: () => dispatch({ type: RESET_STATE })
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapActionToProps
  )(UserInfo)
);
